export default {
  title: 'Components/Navigation/cobalt-tabs-vertical',
  tags: ['autodocs'],
  argTypes: {
    activeTabIndex: {
      type: { name: 'number' },
      control: { type: 'number' },
      description: 'Set a tab as active by providing the index (tab can not be disabled)',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 0 }
      }
    },
    width: {
      type: { name: 'string' },
      options: ['small', 'medium', 'large'],
      control: { type: 'select' },
      description: 'Change the width of the tab list.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'small' }
      }
    },
    cobaltTabChange: {
      action: 'cobaltTabChange',
      description: 'Custom event emitted on tab index change, containing the current (currentTab) and the previous tab (previousTab)',
      table: {
        type: {
          summary: 'Framework integration',
          detail:
            'React: onCobaltTabChange={handleChange}\nVue:@cobaltTabChange="handleChange"\nAngular:(cobaltTabChange)="handleChange()"\nVanillaJs:.addEventListener("cobaltTabChange", (event) => {//handle change});'
        }
      }
    }
  }
}

const Template = args => {
  return `
<style>
  .custom-panel-content-class {
    padding: 0 var(--number-spacing-medium);
  }
</style>
<cobalt-tabs-vertical active-tab-index="${args.activeTabIndex}" width="${args.width}">
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-vertical>
`
}

export const Default = Template.bind({})
Default.args = {
  activeTabIndex: 0,
  width: 'small'
}

const TemplateWithNotificationPill = () => {
  return `
<style>
  .custom-panel-content-class {
    padding: 0 var(--number-spacing-medium);
  }
</style>
<cobalt-tabs-vertical>
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline" notification-pill-number="2">
    <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-vertical>
`
}

export const WithNotificationPill = TemplateWithNotificationPill.bind({})

const TemplateOnChangeEvent = () => {
  return `
<style>
  .custom-panel-content-class {
    padding: 0 var(--number-spacing-medium);
  }
</style>
<script>
  document.querySelector('#tab-on-change').addEventListener('cobaltTabChange', (e) => {
    document.querySelector('#tab-change-infos').textContent = JSON.stringify(e.detail)
  })
</script>
<div style="display:flex; flex-direction: column; gap: var(--number-spacing-large);">
  <p class="typography-body-medium-regular">tabs infos sent on change: <span id="tab-change-infos">no event emitted yet</span></p>
  <cobalt-tabs-vertical id="tab-on-change">
    <cobalt-tab-panel label="Tab 1">
      <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
    </cobalt-tab-panel>
    <cobalt-tab-panel label="Tab 2">
      <div class="custom-panel-content-class typography-body-medium-regular">content 2</div>
    </cobalt-tab-panel>
    <cobalt-tab-panel label="Tab 3">
      <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
    </cobalt-tab-panel>
  </cobalt-tabs-vertical>
</div>
`
}

export const OnChangeEvent = TemplateOnChangeEvent.bind({})
